function trackingPush(object) {
    setTimeout(function () {
        if (cookiehub && cookiehub.hasInitialised) {
            if (cookiehub.hasConsented("analytics")) {
                _mtm.push(object);
                console.log(_mtm, "_mtm");
            }
        }
    }, 500);
}

function trackingView() {

    const mtmScriptTag = document.querySelector('[data-mtm-url]');

    if (!mtmScriptTag) {
        console.info('matomo tracking not configured');
        return;
    }

    let matmoScriptUrl = mtmScriptTag.getAttribute('data-mtm-url');

    var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = matmoScriptUrl;
    s.parentNode.insertBefore(g, s);

    _mtm.push({
        event: "mtm.Start",
        "mtm.startTime": new Date().getTime(),
    });
}

window.trackingPush = trackingPush;
window.trackingView = trackingView;

const isBackend = document.body.classList.contains("neos-backend");

if (!isBackend) {
    const body = document.querySelector("body");
    const hero = document.querySelector("[data-tracking-view]");

    if (body.classList.contains("document-analyses-profile")) {
        if (hero) {
            trackingPush({
                event: hero.getAttribute("data-tracking-view-name"),
                profile_title: hero.getAttribute("data-tracking-view-title"),
            });
        }
    }

    if (body.classList.contains("document-analyses-analyse")) {
        if (hero) {
            trackingPush({
                event: hero.getAttribute("data-tracking-view-name"),
                analysis_title: hero.getAttribute("data-tracking-view-title"),
            });
        }
    }

    if (body.classList.contains("document-career-article")) {
        if (hero) {
            trackingPush({
                event: "job_view",
                job_title: hero.getAttribute("data-tracking-view-title"),
            });
        }

        const careerBtn = document.getElementById("careerFormToggle");
        if (careerBtn) {
            careerBtn.addEventListener("click", () => {
                trackingPush({
                    event: "job_application",
                    job_application: hero.getAttribute("data-tracking-view-title"),
                });
            });
        }
    }

    const overlayBoxes = document.querySelectorAll(".nav-overlay__boxes a");
    if (overlayBoxes) {
        overlayBoxes.forEach((box) => {
            box.addEventListener("click", () => {
                trackingPush({
                    event: box.getAttribute("data-tracking-click-name"),
                    login_portal: box.getAttribute("data-tracking-click-title"),
                });
            });
        });
    }

    const accordions = document.querySelectorAll("[data-tracking-click-accordion]");
    if (accordions) {
        accordions.forEach((accordion) => {
            const links = accordion.querySelectorAll("a");
            links.forEach((link) => {
                link.addEventListener("click", () => {
                    const accordionItem = link.closest("[data-tracking-click]");
                    trackingPush({
                        event: accordionItem.getAttribute("data-tracking-click-name"),
                        news_title: accordionItem.getAttribute("data-tracking-click-title"),
                    });
                });
            });
        });
    }
}
